import type { Translations } from "./pt";

export const es: Translations = {
  nav: {
    home: "Inicio",
    transactions: "Movimientos",
    charts: "Gráficos",
    goals: "Metas",
    budgets: "Presupuestos",
    reports: "Informes",
    family: "Familia",
    admin: "Admin",
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    settings: "Configuración",
    whatsapp: "WhatsApp",
    bills: "Facturas",
    adminPanel: "Panel Admin",
    logout: "Cerrar sesión",
  },

  dashboard: {
    title: "Panel Financiero",
    monthBalance: "SALDO DEL MES",
    income: "INGRESOS",
    expenses: "GASTOS",
    savingsRate: "TASA DE AHORRO",
    recentTransactions: "Movimientos Recientes",
    noTransactions: "Sin movimientos este mes",
    addFirst: "Agrega tu primer movimiento",
    incomeVsExpenses: "Ingresos vs Gastos",
    expensesByCategory: "Gastos por Categoría",
    balanceEvolution: "Evolución del Saldo",
    noExpenses: "Sin gastos registrados este mes",
    welcome: "¡Bienvenido a Bolso!",
    welcomeNew: "Nuevo",
    welcomeDesc: "Registra tus gastos en segundos — por el sitio, por voz o directamente en WhatsApp.",
    byApp: "Por el sitio",
    byAppDesc: "Toca + para agregar un movimiento",
    byVoice: "Por voz",
    byVoiceDesc: 'Di "gasolina 50 euros" y listo',
    byWhatsApp: "Por WhatsApp",
    byWhatsAppDesc: "Envía un mensaje o audio sin abrir el sitio",
    linkWhatsApp: "Vincular WhatsApp",
    alreadyKnow: "Ya sé usarlo, cerrar",
    inviteTitle: "Invita a alguien a probarlo",
    inviteDescription: "Comparte Bolso por WhatsApp. El acceso es gratuito durante el período de prueba.",
    inviteButton: "Compartir por WhatsApp",
    trialDays: "Quedan {days} días de prueba gratuita",
    trialToday: "Último día de la prueba gratuita",
    trialEnded: "Período de prueba gratuita finalizado",
  },

  transactions: {
    title: "Movimientos",
    new: "Nuevo Movimiento",
    edit: "Editar Movimiento",
    delete: "Eliminar",
    confirmDelete: "¿Eliminar movimiento?",
    confirmDeleteDesc: "Esta acción no se puede deshacer.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    type: "Tipo",
    income: "Ingreso",
    expense: "Gasto",
    transfer: "Transferencia",
    amount: "Importe",
    description: "Descripción",
    category: "Categoría",
    date: "Fecha",
    notes: "Notas",
    save: "Guardar",
    noTransactions: "Sin movimientos encontrados",
    search: "Buscar movimientos...",
    filter: "Filtrar",
    all: "Todos",
    receipt: "Comprobante",
    aiCategorized: "Categorizado por IA",
    addTransaction: "Agregar movimiento",
  },

  goals: {
    title: "Metas",
    new: "Nueva Meta",
    edit: "Editar Meta",
    delete: "Eliminar Meta",
    name: "Nombre",
    targetAmount: "Importe Objetivo",
    currentAmount: "Importe Actual",
    deadline: "Plazo",
    icon: "Ícono",
    color: "Color",
    linkedCategory: "Categoría vinculada (opcional)",
    progress: "Progreso",
    completed: "Completada",
    active: "Activa",
    cancelled: "Cancelada",
    noGoals: "Sin metas creadas",
    createFirst: "Crea tu primera meta financiera",
    save: "Guardar",
    cancel: "Cancelar",
    of: "de",
    daysLeft: "días restantes",
    overdue: "Plazo vencido",
    noDeadline: "Sin plazo definido",
  },

  budgets: {
    title: "Presupuestos",
    new: "Nuevo Presupuesto",
    edit: "Editar Presupuesto",
    delete: "Eliminar",
    category: "Categoría",
    limit: "Límite",
    spent: "Gastado",
    remaining: "Restante",
    month: "Mes",
    year: "Año",
    noBudgets: "Sin presupuestos definidos",
    createFirst: "Define límites de gasto por categoría",
    save: "Guardar",
    cancel: "Cancelar",
    of: "de",
    alert80: "80% del límite alcanzado",
    alert100: "¡Límite alcanzado!",
    used: "utilizado",
  },

  reports: {
    title: "Informes",
    period: "Período",
    monthly: "Mensual",
    annual: "Anual",
    byCategory: "Por Categoría",
    family: "Familiar",
    individual: "Individual",
    export: "Exportar",
    income: "Ingresos",
    expenses: "Gastos",
    balance: "Saldo",
    noData: "Sin datos para el período seleccionado",
  },

  family: {
    title: "Familia",
    create: "Crear Grupo Familiar",
    join: "Unirse a un Grupo",
    inviteCode: "Código de Invitación",
    members: "Miembros",
    admin: "Admin",
    member: "Miembro",
    leave: "Salir del Grupo",
    noFamily: "No perteneces a ningún grupo familiar",
    createOrJoin: "Crea o únete a un grupo para compartir finanzas",
    name: "Nombre del Grupo",
    save: "Guardar",
    cancel: "Cancelar",
    copyCode: "Copiar Código",
    codeCopied: "¡Código copiado!",
  },

  settings: {
    title: "Configuración",
    profile: "Perfil",
    preferences: "Preferencias",
    currency: "Moneda",
    language: "Idioma",
    save: "Guardar",
    saved: "¡Guardado!",
    cancel: "Cancelar",
    currencies: {
      BRL: "Real Brasileño (R$)",
      EUR: "Euro (€)",
      USD: "Dólar Estadounidense ($)",
      GBP: "Libra Esterlina (£)",
    },
    languages: {
      pt: "Português",
      en: "English",
      es: "Español",
      it: "Italiano",
    },
    categories: {
      title: "Mis categorías",
      description: "Crea categorías propias para organizar tus gastos e ingresos.",
      expense: "Gastos",
      income: "Ingresos",
      namePlaceholder: "Nombre de la categoría",
      add: "Agregar categoría",
      edit: "Editar categoría",
      save: "Guardar categoría",
      cancel: "Cancelar",
      delete: "Eliminar categoría",
      empty: "No hay categorías personalizadas",
      deleteConfirm: "¿Eliminar esta categoría? Los registros existentes se conservarán.",
      parent: "Categoría principal",
      noParent: "Sin categoría principal",
      subcategory: "Subcategoría",
      created: "¡Categoría creada!",
      updated: "¡Categoría actualizada!",
      deleted: "¡Categoría eliminada!",
    },
  },

  auth: {
    login: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    confirmPassword: "Confirmar Contraseña",
    forgotPassword: "Olvidé mi contraseña",
    loginWithManus: "Entrar con Manus",
    loginWithGoogle: "Entrar con Google",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    verifyEmail: "Verifica tu correo",
    verifyEmailDesc: "Enviamos un enlace de confirmación a",
    resendEmail: "Reenviar correo",
    resetPassword: "Restablecer Contraseña",
    newPassword: "Nueva Contraseña",
    resetSuccess: "¡Contraseña restablecida con éxito!",
    logout: "Cerrar sesión",
  },

  whatsapp: {
    title: "Configuración de WhatsApp",
    linked: "WhatsApp vinculado",
    notLinked: "WhatsApp no vinculado",
    link: "Vincular WhatsApp",
    unlink: "Desvincular",
    phone: "Número de teléfono",
    verifyCode: "Código de verificación",
    step1: "Guarda el número de Bolso",
    step2: 'Envía el mensaje "join ago-family"',
    step3: "Genera tu código de vinculación",
    step4: "Envía el código por WhatsApp",
    generate: "Generar Código",
    copy: "Copiar",
    copied: "¡Copiado!",
    commands: "Comandos disponibles",
    cmdBalance: '"saldo" — ver saldo del mes',
    cmdSummary: '"resumen" — resumen de gastos',
    cmdHelp: '"ayuda" — ver todos los comandos',
  },

  common: {
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    close: "Cerrar",
    back: "Volver",
    next: "Siguiente",
    confirm: "Confirmar",
    search: "Buscar",
    filter: "Filtrar",
    noData: "Sin datos",
    tryAgain: "Intentar de nuevo",
    comingSoon: "Próximamente",
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre",
    months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
  },

  voice: {
    title: "Entrada por Voz",
    hold: "Mantén para grabar",
    release: "Suelta para procesar",
    processing: "Procesando...",
    confirm: "Confirmar movimiento",
    retry: "Intentar de nuevo",
    error: "No se pudo procesar el audio",
    noMic: "Micrófono no disponible",
    speakTransaction: "Di tu movimiento",
    idleHint: 'Di algo como "gasté 50 euros en el mercado"',
    recordingHint: "Grabando... toca para detener",
    manualEntry: "Registrar manualmente",
    startRecording: "Iniciar grabación",
    stopRecording: "Detener grabación",
    microphoneDenied: "Permiso de micrófono denegado. Revisa la configuración del navegador.",
    unsupportedBrowser: "Este navegador no ofrece un formato de audio compatible. Registra manualmente.",
    exampleExpense: '"Gasté 45 euros en el supermercado"',
    exampleIncome: '"Recibí 3500 de sueldo"',
    exampleFuel: '"Pagué 80 de gasolina"',
  },

  bills: {
    title: "Facturas",
    payable: "Por Pagar",
    receivable: "Por Cobrar",
    all: "Todas",
    pending: "Pendientes",
    paid: "Pagadas",
    new: "Nueva Factura",
    edit: "Editar Factura",
    delete: "Eliminar",
    markPaid: "Marcar como pagada",
    markUnpaid: "Deshacer pago",
    dueDate: "Vencimiento",
    amount: "Monto",
    type: "Tipo",
    recurrence: "Recurrencia",
    recurrenceNone: "Sin recurrencia",
    recurrenceWeekly: "Semanal",
    recurrenceMonthly: "Mensual",
    recurrenceYearly: "Anual",
    notes: "Notas",
    category: "Categoría",
    noBills: "No hay facturas registradas",
    addFirst: "Agrega tu primera factura por pagar o cobrar",
    dueSoon: "Próximas facturas",
    overdue: "Vencida",
    dueToday: "Vence hoy",
    dueTomorrow: "Vence mañana",
    confirmDelete: "¿Eliminar factura?",
    confirmDeleteDesc: "Esta acción no se puede deshacer.",
    titleLabel: "Título",
    titlePlaceholder: "Ej: Alquiler, Factura de luz...",
    save: "Guardar",
    cancel: "Cancelar",
  },

  admin: {
    title: "Panel de Administración",
    subtitle: "Visión general de usuarios y configuración del beta",
    totalUsers: "Total de usuarios",
    activeUsers: "Activos (7 días)",
    inactiveUsers: "Inactivos",
    totalTransactions: "Total de movimientos",
    betaExpiry: "Fecha de cierre del período de pruebas",
    noExpiry: "Sin fecha de cierre definida.",
    setExpiry: "Definir fecha de cierre",
    saveDate: "Guardar fecha",
    registeredUsers: "Usuarios Registrados",
    inviteAccess: "Acceso por invitación",
    inviteMode: "Modo restringido",
    inviteModeDesc: "Cuando está activo, solo los correos autorizados pueden crear cuenta.",
    enableRestrict: "Restringir acceso",
    disableRestrict: "Abrir acceso",
    authorizedEmails: "Correos autorizados",
    addEmail: "Agregar correo",
    removeEmail: "Eliminar",
    copyEmails: "Copiar todos",
    maxSlots: "Límite de plazas",
    slotsUsed: "plazas usadas",
    back: "← Volver",
  },
};
